export const getReportsState = state => state.reports


// WEBPACK FOOTER //
// ./web/js/reports/selectors.js